import React, { FC } from 'react';
import { useLocation, matchPath } from 'react-router';
import classNames from 'classnames';
import { Brand } from '@clearcover/atlas';
import clearcover_agent_hub_logo from 'Shared/assets/images/clearcover_agent_hub_logo.png';
import { getSalutation } from 'Shared/utils';
import { useAuth0 } from 'Auth';
import { Breadcrumbs } from './Breadcrumbs/Breadcrumbs';
import styles from './styles.module.css';

export const Header: FC = () => {
  const { user, logout } = useAuth0();
  const { pathname } = useLocation();

  if (!user) {
    return null;
  }

  const isPartnerDetailsPath = !!matchPath(
    pathname,
    '/admin/partners/:id/details'
  );

  return (
    <header className={styles.header}>
      <div className={styles.logo}>
        <Brand />
      </div>
      <div className={styles.breadcrumbs}>
        <Breadcrumbs />
      </div>
      {isPartnerDetailsPath && (
        <div className={styles.developerPortal}>
          <a href="https://developer.clearcover.com/" target="blank">
            Clearcover Developer Portal
          </a>
        </div>
      )}
      <div className={styles.training}>
        <a href="https://resources.clearcover.com/hc/en-us" target="blank">
          <img
            src={clearcover_agent_hub_logo}
            alt="Clearcover Agent Hub"
            className={styles.hubLogo}
          />
        </a>
      </div>
      <div className={styles.right}>
        <div className={styles.greeting}>
          <div
            className={classNames(styles.greetingText, 'fs-mask')}
            data-testid="header-greeting"
          >
            {`Good ${getSalutation()}, ${user.firstName}`}
          </div>
          <div
            className={styles.logout}
            onClick={logout}
            data-testid="header-logout"
          >
            Logout
          </div>
        </div>
        <div className={styles.bubble}>
          {user.firstName[0]}
          {user.lastName[0]}
        </div>
      </div>
    </header>
  );
};
